export default __webpack_public_path__ + "static/Asset 4@300x-b8fc251e4a1db1276d32b598e1969401.png";